export const styles = {
  header: {
    alignItems: "center",
  },
};
